import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { Job, JobType } from '../../_types';

export default function useOrganizationUserImport(
  organizationId: string,
  id: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/phoenix/job-service/v1/organizations/${organizationId}/jobs/job-type/${JobType.ImportUsers.toString()}/jobs/${id}`;
  return useQuery<Job, ServerErrorResponse>(
    ['organization_user_import', organizationId, id],
    async () => {
      try {
        if (!organizationId || !id) {
          return null;
        }
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: false,
      enabled: !!organizationId && !!id,
      ...options,
    }
  );
}
